import React from 'react'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'

import './style.scss'
import l8n from 'l8n'
import { sprintf } from 'sprintf-js'
import renderHTML from 'react-render-html'

class Footer extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="footer__bottom">
          <Row>
            <Col className="text-center">
              {renderHTML(l8n.p_footer_phone)}<br/>
              <a href={`mailto:${l8n.p_footer_email}`}><strong>{l8n.p_footer_email}</strong></a><br/>
              {renderHTML(l8n.p_footer_address)}<br/>
              {sprintf(l8n.p_footer_copyright, (new Date()).getFullYear())}<br/>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Layout/Footer/index.js